import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { api, apiPublic } from '@/plugins/axios.js'
import { vue } from '@/main.js'

// Retorna os dados por equipe
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da Equipe
 */
export async function getDadosPorEquipe(cod_ibge, nu_ine) {
  try {
    const { data } = await api.get(
      `/app/vacina-idade-certa/${cod_ibge}/vacina/26/equipe/${nu_ine}`
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

// Retorna os dados por microárea
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da Equipe
 */
export async function getDadosPorMicroarea(cod_ibge, nu_ine, microarea) {
  try {
    const { data } = await api.get(
      `/app/vacina-idade-certa/${cod_ibge}/vacina/26/equipe/${nu_ine}/micro-area/${microarea}`
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

export function formatarCadastrosComDoses(cadastros) {
  const data = cadastros.map((item, index) => {
    const vacinasPendentes = JSON.parse(item.vacinas_pendentes)
    const vacinasAplicadas = JSON.parse(item.vacinas_aplicadas)

    const coresPneumococica = [
      {
        dose: '1ª DOSE',
        cor: 'white',
        dt_aplicacao_br: '',
      },
      {
        dose: '2ª DOSE',
        cor: 'white',
        dt_aplicacao_br: '',
      },
      {
        dose: 'REFORÇO',
        cor: 'white',
        dt_aplicacao_br: '',
      },
      {
        dose: 'ÚNICA',
        cor: 'white',
        dt_aplicacao_br: '',
      },
    ]
    const primeiraDosePneumococica = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '26',
      '1'
    )
    const segundaDosePneumococica = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '26',
      '2'
    )
    const reforcoPneumococica = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '26',
      '38'
    )
    const unicaPneumococica = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '26',
      '9'
    )

    if (primeiraDosePneumococica.tipo == 'aplicada') {
      coresPneumococica[0].cor = 'green'
      coresPneumococica[0].dt_aplicacao_br =
        primeiraDosePneumococica.dt_aplicacao_br
      coresPneumococica[0].dose_anterior =
        primeiraDosePneumococica.dose_anterior
    } else {
      coresPneumococica[0].cor = primeiraDosePneumococica.cor
      coresPneumococica[0].dt_aplicacao_br = '2 meses'
      coresPneumococica[0].sg_d = primeiraDosePneumococica.sg_d
      coresPneumococica[0].sg_im = primeiraDosePneumococica.sg_im
    }

    if (segundaDosePneumococica.tipo == 'aplicada') {
      coresPneumococica[1].cor = 'green'
      coresPneumococica[1].dt_aplicacao_br =
        segundaDosePneumococica.dt_aplicacao_br
      coresPneumococica[1].dose_anterior = segundaDosePneumococica.dose_anterior
    } else {
      coresPneumococica[1].cor = segundaDosePneumococica.cor
      coresPneumococica[1].dt_aplicacao_br = '4 meses'
      coresPneumococica[1].sg_d = segundaDosePneumococica.sg_d
      coresPneumococica[1].sg_im = segundaDosePneumococica.sg_im
    }

    if (reforcoPneumococica.tipo == 'aplicada') {
      coresPneumococica[2].cor = 'green'
      coresPneumococica[2].dt_aplicacao_br = reforcoPneumococica.dt_aplicacao_br
      coresPneumococica[2].dose_anterior = reforcoPneumococica.dose_anterior
    } else {
      coresPneumococica[2].cor = reforcoPneumococica.cor
      coresPneumococica[2].dt_aplicacao_br = '12 meses'
      coresPneumococica[2].sg_d = reforcoPneumococica.sg_d
      coresPneumococica[2].sg_im = reforcoPneumococica.sg_im
    }

    if (unicaPneumococica.tipo == 'aplicada') {
      coresPneumococica[3].cor = 'green'
      coresPneumococica[3].dt_aplicacao_br = unicaPneumococica.dt_aplicacao_br
      coresPneumococica[3].dose_anterior = unicaPneumococica.dose_anterior
    } else {
      coresPneumococica[3].cor = 'white'
      coresPneumococica[3].dt_aplicacao_br = '12 meses a 4 anos'
      coresPneumococica[3].sg_d = unicaPneumococica.sg_d
      coresPneumococica[3].sg_im = unicaPneumococica.sg_im
    }

    return {
      index: index,
      ...item,
      coresPneumococica,
    }
  })
  return data
}

function encontrarDose(vacinasPendentes, vacinasAplicadas, id_im, id_d) {
  if (vacinasPendentes != null) {
    const dosePendente = vacinasPendentes.find(
      (el) => el.id_im == Number(id_im) && el.id_d == Number(id_d)
    )
    if (dosePendente !== undefined) {
      return {
        tipo: 'pendente',
        cor: 'red',
        dt_aplicacao_br: '',
        sg_d: dosePendente.sg_d,
        sg_im: dosePendente.sg_im,
      }
    }
  }
  if (vacinasAplicadas != null) {
    const doseAplicada = vacinasAplicadas.find(
      (el) => el.id_imuno == id_im && el.id_dose_imuno == id_d
    )
    if (doseAplicada !== undefined) {
      return {
        tipo: 'aplicada',
        dt_aplicacao: doseAplicada.dt_aplicacao,
        dt_aplicacao_br: doseAplicada.dt_aplicacao_br,
        dose_anterior: doseAplicada.dose_anterior,
        id_dose_imuno: doseAplicada.id_dose_imuno,
      }
    }
  }
  return {
    tipo: 'pendente',
    cor: 'white',
    dt_aplicacao_br: '',
    sg_d: '',
    sg_im: '',
  }
}

export function exibirVermelhos(cadastros) {
  const cadastrosFormatados = formatarCadastrosComDoses(cadastros)
  const filtro = cadastrosFormatados.filter((item) => {
    if (item.coresPneumococica.find((element) => element.cor === 'red')) {
      return true
    }
  })
  return filtro
}

export function exibirVerdes(cadastros) {
  const cadastrosFormatados = formatarCadastrosComDoses(cadastros)
  const filtro = cadastrosFormatados.filter((item) => {
    if (
      item.coresPneumococica.every(
        (element) => element.cor === 'green' || element.cor === 'white'
      )
    ) {
      return true
    }
  })
  return filtro
}

export function generatePdf(cadastros, selectEquipe, microArea) {
  const title = 'Pneumocócica 10V (conjugada)'
  const titlePdfSave = utils.methods.titlePdf(title, selectEquipe.no_equipe)
  const description =
    'Situação vacinal de pessoas com Pneumocócica 10V (conjugada)'
  const headers = [
    'NOME',
    'NASCIMENTO',
    'MÃE',
    'MA',
    'PNEUMOCÓCICA 10V (CONJUGADA)',
    'DOCUMENTO',
  ]

  const doses = formatarCadastrosComDoses(cadastros)

  const dataPdf = doses.map((item, index) => {
    const documento = []
    if (cadastros[index].nu_cpf)
      documento.push(`CPF ${cadastros[index].nu_cpf}`)
    if (cadastros[index].nu_cns)
      documento.push(`CNS ${cadastros[index].nu_cns}`)

    return {
      no_cidadao: item.no_cidadao,
      dt_nascimento: utils.methods.formatDate(item.dt_nascimento),
      no_mae: item.no_mae,
      ma: item.micro_area,
      pneumococica: item.coresPneumococica
        .map((dose) => `${dose.dose} - ${dose.dt_aplicacao_br}`)
        .join('\n'),
      documento: documento.join('\n'),
    }
  })

  const doc = new jsPDF(utils.methods.encryptionPdf())
  const table = utils.methods.createTablePdf(dataPdf)

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64) => {
      let y = utils.methods.headerPdf(doc, base64, title, description)

      y = utils.methods.bodyPdf(
        doc,
        [
          { label: 'Equipe', value: selectEquipe.no_equipe },
          { label: 'CNES', value: selectEquipe.nu_cnes },
          { label: 'INE', value: selectEquipe.nu_ine },
          { label: 'Microárea', value: microArea },
        ],
        y
      )

      doc.autoTable({
        head: [headers],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        theme: 'striped',
        startY: y,
        showHead: 'firstPage',
        willDrawCell: (data) => {
          if (data.row.section === 'head') {
            doc.setTextColor(0, 0, 0)
          }
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)
      doc.save(`${titlePdfSave}.pdf`)

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}

export const dataFields = {
  Nome: 'no_cidadao',
  Nascimento: {
    field: 'dt_nascimento',
    callback: (value) => {
      return value !== null ? utils.methods.formatDate(value) : ''
    },
  },
  Mãe: 'no_mae',
  MA: 'micro_area',
}
